function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.042,
    height: 24.042,
    viewBox: "0 0 24.042 24.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22",
    transform: "rotate(45 1.415 3.415)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h30v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 23",
    transform: "rotate(-45 25.606 10.607)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h30v4H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/BTN_Close.15cdaadf7716d3f4cce86e3ce4c5c752.svg";
export { ForwardRef as ReactComponent };